<section class="centered-fullwidth flex flex-col gap-y-7 py-7">
  @if (data.title; as title) {
    <div class="px-5">
      <app-title [title]="title" size="h1" />
    </div>
  }
  <div class="relative">
    <ng-container *ngTemplateOutlet="blobTemplate; context: { zIndex: 10 }" />
    <div class="relative z-20 flex min-h-10 flex-col items-center gap-y-14 bg-gray-light px-5 leading-none">
      <div class="flex min-h-48 flex-col justify-center gap-y-14 desk:my-[-75px]">
        @if (estimatedPricesLoaded()) {
          @let prices = estimatedPrices();
          <div class="grid grid-cols-1 gap-y-5 desk:grid-cols-[450px_414px] desk:gap-x-14 desk:py-8">
            <div class="flex flex-col gap-y-1">
              <span class="font-title text-[18px] desk:text-[25px]">{{ "GLOBAL.BETWEEN" | translate }}</span>
              <div class="flex flex-col items-center">
                <div class="flex w-full gap-x-3 font-title text-[35px] desk:text-[55px]">
                  <span class="flex items-baseline">
                    <span class="text-nowrap">{{ prices.total.min | number: "1.0-0" }}</span>
                    <span class="text-[25px] desk:text-[43px]">&nbsp;€</span>
                  </span>
                  <span class="self-center text-[18px] desk:text-[25px]">{{
                    "GLOBAL.AND" | translate | lowercase
                  }}</span>
                  <span class="flex">
                    <span class="flex items-baseline">
                      <span class="text-nowrap">{{ prices.total.max | number: "1.0-0" }}</span>
                      <span class="text-[25px] desk:text-[43px]">&nbsp;€</span>
                    </span>
                    <span class="font-sans text-[16px] font-medium"><sup>*</sup></span>
                  </span>
                </div>
              </div>
              <div class="flex flex-col font-bold">
                @if (!data.hideStartingPricePerMonth) {
                  <span>
                    **
                    {{
                      "COMPONENT.ESTIMATEUR-BUDGET-DETAIL-PRIX.STARTING_FROM_PER_MONTH"
                        | translate
                          : {
                              price: prices.startingPricePerMonth | currency: "EUR" : "symbol" : "1.0-0",
                            }
                    }}
                  </span>
                }
                <span>
                  {{ data.hideStartingPricePerMonth ? "**" : "***" }}
                  {{ "COMPONENT.ESTIMATEUR-BUDGET-DETAIL-PRIX.DELIVERY_INCLUDED" | translate }}
                </span>
              </div>
              <div class="flex flex-col justify-center gap-y-2.5">
                <div
                  (click)="showPriceDetail.set(!showPriceDetail())"
                  class="mt-3 flex w-[175px] cursor-pointer select-none items-center gap-x-5 gap-y-1.5 font-bold">
                  <span>{{ "COMPONENT.ESTIMATEUR-BUDGET-DETAIL-PRIX.PRICE_BREAKDOWN_DETAIL" | translate }}</span>
                  <app-svg
                    [ngClass]="{ '-scale-x-100': showPriceDetail() }"
                    [width]="7"
                    class="rotate-90 transition duration-300 ease-in-out"
                    src="assets/icons/caret-right.svg" />
                </div>
                @if (showPriceDetail()) {
                  <div class="flex flex-col gap-y-2.5">
                    <div class="grid grid-cols-[150px_auto] items-center justify-between">
                      <span>{{ "GLOBAL.FURNITURE" | translate }}</span>
                      <span class="text-end">
                        {{ prices.furniture.min | currency: "EUR" : "symbol" : "1.0-0" }}
                        -
                        {{ prices.furniture.max | currency: "EUR" : "symbol" : "1.0-0" }}
                      </span>
                    </div>
                    <div class="grid grid-cols-[150px_auto] items-center justify-between">
                      <span>{{ "GLOBAL.APPLIANCES_AND_SANITARY" | translate }}</span>
                      <span>
                        {{ prices.appliances.min | currency: "EUR" : "symbol" : "1.0-0" }}
                        -
                        {{ prices.appliances.max | currency: "EUR" : "symbol" : "1.0-0" }}
                      </span>
                    </div>
                    <div class="grid grid-cols-[150px_auto] items-center justify-between">
                      <span>{{ "GLOBAL.INSTALLATION_AND_DELIVERY" | translate }}</span>
                      <span>
                        {{ prices.services.min | currency: "EUR" : "symbol" : "1.0-0" }}
                        -
                        {{ prices.services.max | currency: "EUR" : "symbol" : "1.0-0" }}
                      </span>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div>
              <div class="flex flex-col gap-y-4 rounded-3xl bg-anis p-5">
                @let rdv = data.rdv;
                @if (rdv.title; as title) {
                  <app-title [title]="title" size="h2" />
                }
                @if (rdv.text; as text) {
                  <div class="text-base">{{ text }}</div>
                }
                @if (rdv.cta; as cta) {
                  @let gtm = data.gtmConfigCta;
                  <app-button
                    (onButtonClick)="
                      emitGtmEvent({
                        event: gtm?.event,
                        group: gtm?.group,
                        description: gtm?.description,
                        context: gtm?.context,
                        button_text_value: cta.label,
                        event_type: 'click',
                      })
                    "
                    [label]="cta.label"
                    [url]="cta.url"
                    class="self-center"
                    theme="WHITE" />
                }
              </div>
            </div>
          </div>
        } @else {
          <app-loader [text]="'COMPONENT.ESTIMATEUR-BUDGET-DETAIL-PRIX.CALCULATING_CURRENT_PRICE' | translate" />
        }
      </div>
    </div>
    <ng-container *ngTemplateOutlet="blobTemplate; context: { rotate180: true, zIndex: 20, flip: true }" />
  </div>
</section>
<ng-template #blobTemplate let-flip="flip" let-rotate180="rotate180" let-zIndex="zIndex">
  <div
    [ngClass]="{
      'rotate-180': rotate180,
      '-scale-x-100': flip,
    }"
    [style.z-index]="zIndex">
    <app-svg [inline]="true" src="assets/svgs/blob-estimator.svg" />
  </div>
</ng-template>
